class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      //   this.setUnavailable();
    } else {
      this.renderProductInfo();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.toggleAddButton();
      this.updateShippingMeta();
      this.updateSku();
      this.updateVariantName();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        radio => radio.checked
      ).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_image) return;
    const newMedia = document.querySelector(
      `.product__thumbs [data-media-id="${this.currentVariant.featured_image.id}"]`
    );
    if (!newMedia || newMedia === null) return;
    const newMediaThumb = newMedia.parentNode.parentNode;
    if (!newMediaThumb) return;
    let slide_number = newMediaThumb.getAttribute("data-slick-index");
    if (!slide_number) return;
    $(".js-product-slider-thumbs-slides").slick("slickGoTo", slide_number);
    newMedia.click();
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`.product__form`);
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    let that = this;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then(response => response.text())
      .then(responseText => {
        const id = `product-price`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        that.showLoyaltyPoints();
      });
  }

  toggleAddButton() {
    const qtyWrapper = document.querySelector(`.product__form .form__foot`);
    const addButton = document.querySelector(`.product__form .js-ajax-add`);

    if (!addButton) return;

    if (this.currentVariant.available) {
      qtyWrapper.classList.remove("form__foot--disabled");
      addButton.removeAttribute("hidden");
    } else {
      addButton.setAttribute("hidden", true);
      qtyWrapper.classList.add("form__foot--disabled");
    }
  }

  updateShippingMeta() {
    const shippingMetaData = document.querySelectorAll(
      "[data-shipping-metaid]"
    );
    const currentShippingData = document.querySelector(
      `[data-shipping-metaid="${this.currentVariant.id}"]`
    );

    if (!currentShippingData) return;
    for (let i = 0; i < shippingMetaData.length; i++) {
      shippingMetaData[i].setAttribute("hidden", true);
    }
    if (currentShippingData.hasAttribute("hidden")) {
      currentShippingData.removeAttribute("hidden");
    }
  }

  updateSku() {
    const productSku = document.querySelectorAll(".product__sku");
    const currentProductSku = document.querySelector(
      `[data-sku-id="${this.currentVariant.id}"]`
    );

    if (!currentProductSku) return;
    for (let i = 0; i < productSku.length; i++) {
      productSku[i].setAttribute("hidden", true);
    }
    if (currentProductSku.hasAttribute("hidden")) {
      currentProductSku.removeAttribute("hidden");
    }
  }

  updateVariantName() {
    if (!this.currentVariant.title) return;
    const selectedVariantLabel = document.querySelector(
      ".product-form__input .form__label span"
    );
    if (selectedVariantLabel) {
      selectedVariantLabel.textContent = this.currentVariant.title;
    }
  }

  //   setUnavailable() {
  //     const addButton = document
  //       .getElementById(`product-form-${this.dataset.section}`)
  //       ?.querySelector('[name="add"]');
  //     if (!addButton) return;
  //     addButton.textContent = window.variantStrings.unavailable;
  //   }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[variant][type="application/json"]').textContent);
    return this.variantData;
  }
  getProductData() {
    this.productData =
      this.productData ||
      JSON.parse(this.querySelector('[product][type="application/json"]').textContent);
    return this.productData;
  }
  showLoyaltyPoints() {
    let that = this;
    let tags = that.getProductData().tags.map((item)=>item.toLowerCase());
    let hasBFCMTag = window.enableSaleEvent && tags && tags.find((tag)=>{let tagSplit = tag.split('bfcm'); return (tagSplit[0] == '' && +tagSplit[1] > 0 ) && tag.indexOf('-') == -1 || tag == 'sale'}) != null;
    document.querySelectorAll('.product__form .earn-points, .product__content__loyalty-tooltip').forEach((item)=>{
      if (hasBFCMTag) {
        item.style.display = 'none';
        item.closest('.btn, button')?.classList.add('without-points');
        return;
      }
      if (that.currentVariant.price !== that.currentVariant.compare_at_price) {
        item.style.display = 'none';
        item.closest('.btn, button')?.classList.add('without-points');
      } else {
        item.style.display = '';
      }
    });
    document.querySelectorAll('.product__form .form__btn')?.forEach((button)=>{
      if (hasBFCMTag) {
        button.classList?.add('without-points');
        return
      }
      if (that.currentVariant.price !== that.currentVariant.compare_at_price) {
        button.classList?.add('without-points')
      } else {
        button.classList?.remove('without-points')
      }
    });
  }
}

customElements.define("variant-radios", VariantRadios);
